export const getLocationSlug = location =>
  location && location.seo && location.seo.slug ? location.seo.slug : location && location.id ? location.id : '';

export const getLocationCity = location => {
  if (!location || !location.address) return '';
  if (typeof location.address === 'string') return '';
  return location.address.city || '';
};

export const getLocationAddressLabel = location => {
  if (!location || !location.address) return '';
  if (typeof location.address === 'string') return location.address;
  if (location.address.label) return location.address.label;
  return [location.address.street && `${location.address.street} ${location.address.houseNumber || ''}`, location.address.zip, location.address.city]
    .filter(Boolean)
    .join(', ');
};

export const getHeroImage = location => {
  if (!location || !location.images || location.images.length === 0) {
    return '/assets/location-search/background.jpg';
  }
  return location.images[0].src || location.images[0].fileUrl || location.images[0].url || '/assets/location-search/background.jpg';
};

export const formatGuests = location => {
  if (!location) return 'Gästezahl auf Anfrage';
  if (location.minimumNumberOfGuests && location.maximumNumberOfGuests) {
    return `${location.minimumNumberOfGuests}-${location.maximumNumberOfGuests} Gäste`;
  }
  if (location.maximumNumberOfGuests) {
    return `bis ${location.maximumNumberOfGuests} Gäste`;
  }
  return 'Gästezahl auf Anfrage';
};

export const formatRating = location => {
  const fallbackRating =
    location &&
    location.ratings &&
    location.ratings
      .filter(item => item.rating)
      .sort((a, b) => (Number.parseInt(b.number) || 0) - (Number.parseInt(a.number) || 0))[0];
  const rating = location && (location.bestRating || fallbackRating);
  if (!rating) return null;
  const value = rating.value || rating.rating;
  if (!value) return null;
  const count = rating.count || rating.number;
  return `${value.toString().replace('.', ',')} Sterne${count ? ` (${count})` : ''}`;
};

export const buildRegionLabel = region => {
  if (!region) return 'Deutschland, Österreich und Schweiz';
  return region
    .split('-')
    .filter(Boolean)
    .map(part => part.substring(0, 1).toUpperCase() + part.substring(1))
    .join(' ');
};

export const GOOGLE_MAPS_API_KEY = 'AIzaSyAUO_P0hkO_78JaRqQLYEX3CLvHDVvpAkQ';

export const LOCATION_MARKER_ICON = {
  path:
    'M12 2C8.1 2 5 5.1 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.9-3.1-7-7-7zm0 9.7A2.7 2.7 0 1 1 12 6.3a2.7 2.7 0 0 1 0 5.4z',
  fillColor: '#a85f66',
  fillOpacity: 1,
  strokeColor: '#ffffff',
  strokeWeight: 2,
  scale: 1.55,
  anchor: { x: 12, y: 22 },
};

export const getLocationPosition = location => {
  if (!location) return null;
  const lat = Number.parseFloat(location.lat || location.latitude);
  const lng = Number.parseFloat(location.lng || location.longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
};
